/* 收益详情 */
<template>
  <div class="income-detail">
    <!-- 头部 -->
    <headerTop title="叮当云帐本"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="none-box">
        <label>累积{{name}}</label>
        <div class="total">
          <span>{{commissionTotal}}</span>
        </div>
        <img class="background" src="../../assets/images/home-bg@2x.png" alt="">
      </div>
      <t-table
        v-if="!(dataFinished && dataList.length == 0) && type !== 'dividend'"
        class="ui-table"
        borderType
        :zebraStripe="false"
      >
        <t-tr align="center">
          <t-th>
            <div class="title">周期</div>
          </t-th>
          <t-th>
            <div class="title">收益</div>
          </t-th>
        </t-tr>
        <van-list
          v-model="dataLoading"
          :finished="dataFinished"
          :finished-text="dataList.length == 0 ? '无更多数据了':'没有更多数据了'"
          @load="getLoadData"
        >
          <t-tr v-for="(item, index) in dataList" :key="index" :tableIndex="index">
            <t-td>
              <div class="date">{{ item.commissionMonth }}</div>
            </t-td>
            <t-td>
              <div class="price">{{ item.commissionPriceSum }}</div>
            </t-td>
          </t-tr>
        </van-list>
      </t-table>
      <t-table
        v-if="!(dataFinished && dataList.length == 0) && type === 'dividend'"
        class="ui-table"
        borderType
        :zebraStripe="false"
      >
        <t-tr align="center">
          <t-th>
            <span class="title">周期</span>
          </t-th>
          <t-th>
            <span class="title">月度业绩</span>
          </t-th>
          <t-th>
            <span class="title">月度收益</span>
          </t-th>
        </t-tr>
        <van-list
          v-model="dataLoading"
          :finished="dataFinished"
          :finished-text="dataList.length == 0 ? '无更多数据了':'没有更多数据了'"
          @load="getLoadData"
        >
          <t-tr v-for="(item, index) in dataList" :key="index" :tableIndex="index">
            <t-td>
              <span class="date">{{ item.month }}</span>
            </t-td>
            <t-td>
              <span class="price">{{ item.achievement }}</span>
            </t-td>
            <t-td>
              <span class="price">{{ item.income }}</span>
            </t-td>
          </t-tr>
        </van-list>
      </t-table>
      <noDataNote v-if="dataFinished && dataList.length === 0" background="#ffffff" :type="2" note="暂无奖励"></noDataNote>
    </div>
  </div>
</template>

<script>
import javaApi from "@/api/javaApi";
import headerTop from "@/components/common/headerTop.vue";
import noDataNote from "@/components/common/noDataNote.vue";
import tTable from "@/components/table/tTable.vue";
import tTh from "@/components/table/tTh.vue";
import tTr from "@/components/table/tTr.vue";
import tTd from "@/components/table/tTd.vue";

export default {
  data() {
    return {
      type: this.$route.query.type,
      name: this.$route.query.name,
      commissionTotal: "",
      dataList: [],
      dataLoading: false,
      dataFinished: false,
      dataTotalPage: 1,
      dataPage: 1,
      dataPageSize: 10
    };
  },
  components: {
    headerTop,
    noDataNote,
    tTable,
    tTh,
    tTr,
    tTd
  },
  created() {},
  mounted() {},
  methods: {
    getLoadData() {
      this.$nextTick(() => {
        this.dataLoad();
      });
    },
    // 获取滚动的数据
    async dataLoad() {
      console.log(1);
      let data = {
        page: this.dataPage,
        page_size: this.dataPageSize
      };
      this.dataLoading = true;

      let tempData;
      let res;
      if (this.type === "commission") {
        res = await javaApi.commissionList(data);
        this.commissionTotal = res.data.total || "0";
        tempData = res.data.commissionList;
      } else if (this.type === "levelAward") {
        res = await javaApi.levelAwardList(data);
        this.commissionTotal = (res.data.total * 0.01).toFixed(2) || "0";
        tempData = res.data.commissionList;
        tempData.forEach(item => {
          Object.assign(item, {
            commissionPriceSum: (item.commissionPrice * 0.01).toFixed(2)
          });
        });
      } else if (this.type === "personally") {
        res = await javaApi.personallyCommission(data);
        this.commissionTotal = (res.data.total * 0.01).toFixed(2) || "0";
        tempData = res.data.commissionList;
        tempData.forEach(item => {
          Object.assign(item, {
            commissionPriceSum: (item.commissionPriceSum * 0.01).toFixed(2)
          });
        });
      } else if (this.type === "dividend") {
        res = await javaApi.dividendList(data);
        this.commissionTotal = res.data.total || "0";
        tempData = res.data.dividends;
      }

      this.dataList = this.dataList.concat(tempData);

      this.dataTotalPage = res.pagination.pageCount;
      this.dataLoading = false;
      if (this.dataPage >= this.dataTotalPage) {
        this.dataFinished = true;
      }
      this.dataPage++;
    }
  }
};
</script>

<style lang="less" scoped>
.income-detail {
  .none-box {
    position: relative;
    margin: 15px 20px 25px;
    label {
      position: absolute;
      font-size: 14px;
      line-height: 1.5;
      color: #ffffff;
      top: 20px;
      left: 55px;
    }
    .total {
      position: absolute;
      top: 50px;
      left: 25px;
      span {
        font-size: 28px;
        line-height: 1.5;
        color: #ffffff;
        font-weight: bold;
      }
    }
    .background {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>